import {Component, OnInit, Input, Output, EventEmitter} from "@angular/core";
import {Service} from "@edp-models/service.model";

@Component({
    selector: "request-service-card",
    templateUrl: "./request-service-card.component.html",
    styleUrls: ["./request-service-card.component.scss"]
})

export class RequestServiceCardComponent implements OnInit {

    @Input() serviceInfo: Service;
    @Input() selected: boolean;
    @Output() selectedCard: EventEmitter<Service> = new EventEmitter<Service>();


    public iconClass: string;

    public ngOnInit() {
        this.setIcon(this.serviceInfo);
    }

    public selectCard() {
        this.selectedCard.emit(this.serviceInfo);
    }

    private setIcon(serviceInfo: Service) {
        switch (serviceInfo.acronym) {
            case "ENERGY":
                this.iconClass = "icon-edponline-Bop-003";
                break;
            case "GENERAL":
                this.iconClass = "icon-edponline-EDP_Online_07";
                break;
            case "SERVICES":
                this.iconClass = "icon-edponline-Bop-002";
                break;
            case "BENEFITS":
                this.iconClass = "icon-edponline-EDP_Online_02";
                break;
            case "EDPHEALTH":
                this.iconClass = "icon-edponline-Bop-052";
                break;
        }
    }
}
